export { default } from './WindStatsTooltip';
